export default __webpack_public_path__ + "static/media/Close.a7058d4f.jpg";